module.exports = __webpack_public_path__ + "static/media/drpic2.3957f471.png";